import type { ColDef } from 'ag-grid-community';

/**
 * Dá a cada coluna um `minWidth` igual ao `width` declarado (quando ela ainda
 * não tem um). Existe por causa do par `width:` + `sizeColumnsToFit()`:
 *
 * `sizeColumnsToFit` espreme TODAS as colunas na largura do viewport e só
 * respeita `minWidth` — o `width` declarado é tratado como mero ponto de
 * partida. Numa grid de 15 colunas em janela comum, cada uma ficava com
 * ~60-70px e o usuário precisava alargar campo a campo (reclamação do dono
 * do produto, 2026-08-30, na Curva ABC da Reposição).
 *
 * Com o `minWidth` espelhando o `width`: em tela larga as colunas continuam
 * crescendo pra preencher (o comportamento que motivou o sizeColumnsToFit);
 * em tela apertada elas param no declarado e a grid rola na horizontal em
 * vez de espremer — que é como a AnaliseGrid, a grid grande do app, sempre
 * funcionou.
 *
 * Colunas `flex` (sem `width`) e colunas que já declaram `minWidth` próprio
 * passam intactas.
 */
export function comLarguraMinima<T>(cols: ColDef<T>[]): ColDef<T>[] {
  return cols.map((c) =>
    typeof c.width === 'number' && c.minWidth == null
      ? { ...c, minWidth: c.width }
      : c,
  );
}
